/* tslint:disable */
type QualityGateProcessStatus =
  'UNPROCESSED' |
  'PROCESSED';
module QualityGateProcessStatus {
  export const UNPROCESSED: QualityGateProcessStatus = 'UNPROCESSED';
  export const PROCESSED: QualityGateProcessStatus = 'PROCESSED';
  export function values(): QualityGateProcessStatus[] {
    return [
      UNPROCESSED,
      PROCESSED
    ];
  }
}

export { QualityGateProcessStatus }